module.exports = fox._r("images/search-del.png", __webpack_public_path__ + "_/_/_/common/frame/images/search-del.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/search-del.png
// module id = 126
// module chunks = 2